import { apiRequest } from "./client";

function projectBase(projectId) {
  return `/projects/${projectId}/real-estate`;
}

export const realEstateApi = {
  listProperties(projectId, params = {}) {
    return apiRequest(`${projectBase(projectId)}/properties`, { params });
  },
  getProperty(projectId, propertyId) {
    return apiRequest(`${projectBase(projectId)}/properties/${propertyId}`);
  },
  createProperty(projectId, payload) {
    return apiRequest(`${projectBase(projectId)}/properties`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  updateProperty(projectId, propertyId, payload) {
    return apiRequest(`${projectBase(projectId)}/properties/${propertyId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  deleteProperty(projectId, propertyId) {
    return apiRequest(`${projectBase(projectId)}/properties/${propertyId}`, {
      method: "DELETE",
    });
  },
  listLeases(projectId, params = {}) {
    return apiRequest(`${projectBase(projectId)}/leases`, { params });
  },
  getLease(projectId, leaseId) {
    return apiRequest(`${projectBase(projectId)}/leases/${leaseId}`);
  },
  createLease(projectId, payload) {
    return apiRequest(`${projectBase(projectId)}/leases`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  updateLease(projectId, leaseId, payload) {
    return apiRequest(`${projectBase(projectId)}/leases/${leaseId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  deleteLease(projectId, leaseId) {
    return apiRequest(`${projectBase(projectId)}/leases/${leaseId}`, {
      method: "DELETE",
    });
  },
  listObligations(projectId, params = {}) {
    return apiRequest(`${projectBase(projectId)}/obligations`, { params });
  },
  getObligation(projectId, obligationId) {
    return apiRequest(`${projectBase(projectId)}/obligations/${obligationId}`);
  },
  createObligation(projectId, payload, idempotencyKey = "") {
    return apiRequest(`${projectBase(projectId)}/obligations`, {
      method: "POST",
      headers: idempotencyKey ? { "x-idempotency-key": idempotencyKey } : undefined,
      body: JSON.stringify(payload),
    });
  },
  generateObligations(projectId, payload, idempotencyKey = "") {
    return apiRequest(`${projectBase(projectId)}/obligations/generate`, {
      method: "POST",
      headers: idempotencyKey ? { "x-idempotency-key": idempotencyKey } : undefined,
      body: JSON.stringify(payload),
    });
  },

  createPaymentLink(projectId, obligationId, { regenerate = false } = {}) {
    return apiRequest(`${projectBase(projectId)}/obligations/${obligationId}/payment-link`, {
      method: "POST",
      body: JSON.stringify({ regenerate }),
    });
  },
  sendObligationNotification(projectId, obligationId, payload = {}, idempotencyKey = "") {
    return apiRequest(`${projectBase(projectId)}/obligations/${obligationId}/notifications`, {
      method: "POST",
      headers: idempotencyKey ? { "x-idempotency-key": idempotencyKey } : undefined,
      body: JSON.stringify(payload),
    });
  },
  runCollectionsAutomation(projectId, payload = {}) {
    return apiRequest(`${projectBase(projectId)}/obligations/automation/run`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  updateObligation(projectId, obligationId, payload) {
    return apiRequest(`${projectBase(projectId)}/obligations/${obligationId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
};
